import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Drawer as MuiDrawer } from '@material-ui/core';
import cn from 'classnames';
import { merge } from 'lodash-es';
import { useDevice } from '../../providers/Device';
import { StandaloneBottomSheet } from '../BottomSheet/StandaloneBottomSheet/StandaloneBottomSheet';
import { CloseButton } from '../CloseButton';
import styles from './Drawer.module.scss';
import { useDrawerStyles } from './Drawer.styles';
export function Drawer(props) {
    const { children, className, header, footer, onCloseButtonClick, disableCloseButton = false, hasTopbar, headerClassName, showDividers = true, minWidth = 444, anchor = 'right', testId, BackdropComponent, disableMobileBottomSheet = false, isMobile, mobileFullHeight = true, bi, noBi } = props, rest = _object_without_properties(props, [
        "children",
        "className",
        "header",
        "footer",
        "onCloseButtonClick",
        "disableCloseButton",
        "hasTopbar",
        "headerClassName",
        "showDividers",
        "minWidth",
        "anchor",
        "testId",
        "BackdropComponent",
        "disableMobileBottomSheet",
        "isMobile",
        "mobileFullHeight",
        "bi",
        "noBi"
    ]);
    const classes = useDrawerStyles();
    const { isMobileDevice } = useDevice();
    const renderAsMobile = isMobile !== null && isMobile !== void 0 ? isMobile : isMobileDevice;
    const renderAsBottomSheet = renderAsMobile && !disableMobileBottomSheet;
    // eslint-disable-next-line custom/no-hardcoded-nobi-in-seagull -- WHY: Drawer composes BiProps and forwards the consumer-supplied bi/noBi to its close button; consumers pass distinct per-drawer close names (backoffice has no BiProvider and passes noBi). Hardcoding 'close' would override those names and break the 8 call sites' typed bi/noBi prop.
    const closeButtonBiProps = noBi ? {
        noBi: true
    } : {
        bi: bi
    };
    const body = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            header && /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.header, headerClassName, {
                    [styles.noDividers]: !showDividers
                }),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.headerContent,
                        children: header
                    }),
                    onCloseButtonClick && !renderAsBottomSheet && /*#__PURE__*/ _jsx(CloseButton, _object_spread_props(_object_spread({}, closeButtonBiProps), {
                        testId: testId && "".concat(testId, "-close-button"),
                        size: "small",
                        onClick: onCloseButtonClick,
                        disabled: disableCloseButton
                    }))
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.content,
                children: children
            }),
            footer && /*#__PURE__*/ _jsx("div", {
                className: cn(styles.footer, {
                    [styles.noDividers]: !showDividers
                }),
                children: footer
            })
        ]
    });
    if (renderAsBottomSheet) {
        var _rest_open;
        return /*#__PURE__*/ _jsx(StandaloneBottomSheet, {
            open: (_rest_open = rest.open) !== null && _rest_open !== void 0 ? _rest_open : false,
            onClose: ()=>{
                var _rest_onClose;
                return (_rest_onClose = rest.onClose) === null || _rest_onClose === void 0 ? void 0 : _rest_onClose.call(rest, {}, 'escapeKeyDown');
            },
            paddingBottom: 0,
            fullHeight: mobileFullHeight,
            BackdropComponent: BackdropComponent,
            children: /*#__PURE__*/ _jsx("div", {
                className: cn(styles.root, styles.mobile),
                children: body
            })
        });
    }
    const modalPropsWithBackdrop = BackdropComponent ? merge({}, rest.ModalProps, {
        BackdropComponent
    }) : rest.ModalProps;
    return /*#__PURE__*/ _jsx(MuiDrawer, _object_spread_props(_object_spread({}, rest), {
        anchor: anchor,
        className: cn({
            [classes.root]: hasTopbar
        }, styles.clickThroughWhenHidden, className),
        "data-testid": testId,
        ModalProps: merge({
            BackdropProps: {
                classes: {
                    root: classes.backdrop
                }
            }
        }, modalPropsWithBackdrop),
        PaperProps: merge({
            classes: {
                root: classes.paper
            }
        }, rest.PaperProps),
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.root,
            style: {
                minWidth
            },
            children: body
        })
    }));
}
